import { VenueCourtsComponent } from './venue-courts/venue-courts.component';
import { VenueDetailsService } from './venue-details.service';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AlertController, IonicModule, NavController, ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { VenueVideoBoardsService } from './venue-video-boards/venue-video-boards.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-venue-details',
  templateUrl: './venue-details.component.html',
  styleUrls: ['./venue-details.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule
  ],
  providers: [
    VenueDetailsService,
    VenueVideoBoardsService
  ]
})
export class VenueDetailsComponent implements OnInit, OnDestroy {
  venueDetailsService = inject(VenueDetailsService);
  private navController = inject(NavController);
  private alertController = inject(AlertController);

  loaded = computed(() => {    
    return !!this.venueDetailsService.venue()
  })

  isIntegrationsModalOpen = false;
  isEditModalOpen = false;
  
  editForm = new FormGroup({
    venueName: new FormControl(this.venueDetailsService.venue()?.venueName, Validators.required),
    venueAbbreviation: new FormControl(this.venueDetailsService.venue()?.venueAbbreviation, Validators.required)
  })

  private readonly destroy$: Subject<void> = new Subject();

  ngOnInit(): void {
    this.venueDetailsService.venue$
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        venue => this.editForm.setValue({
          venueName: venue.venueName,
          venueAbbreviation: venue.venueAbbreviation
        })
      )
  }

  async ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  edit() {
    this.venueDetailsService
      .edit(this.editForm.controls.venueName.value, this.editForm.controls.venueAbbreviation.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        venue => {
          this.venueDetailsService.venue().venueName = venue.venueName;
          this.venueDetailsService.venue().venueAbbreviation = venue.venueAbbreviation;
          this.isEditModalOpen = false;
        }
      )
  }

  async deleteVenue() {

    const alert = await this.alertController.create({
      header: 'Delete venue',
      message: 'You are about to delete venue. This action cannot be undone. Do you want to continue?',
      buttons: [{
        text: 'Delete',
        role: 'destructive',
        handler: () => {
          this.venueDetailsService.deleteVenue()
          .pipe(
            takeUntil(this.destroy$),
          ).subscribe(
            () => this.navController.navigateBack(['smart-venues'])
          )
        }
      },
      {
        text: 'Cancel',
        role: 'cancel'
      }]
    });
  
    await alert.present();
  } 
}
